<!-- <dynamic-form [eventsFromButton]="eventsSubject.asObservable()" (onSubmit)="hello($event)" [fields]="formFeildItems">
</dynamic-form>
<button nz-button (click)="emitEventToChild()">Save</button> -->
<!-- <dynamic-form-expand 
  [eventsFromButton]="eventsSubject.asObservable()" 
  (onSearch)="hello($event)" 
  [fields]="formFeildItems"
  [isCollapseBtn]="true"
  [isClearBtn]="true"
  [numberCollapse]="3"
  >
</dynamic-form-expand> -->

<div class="overflow-auto" nz-row [nzGutter]="24">
  <div nz-col [nzSpan]="4">
  </div>
  <div class="content" nz-col [nzSpan]="16">
    <nz-card>
      <div class="flex justify-between">
          <div class="img-logo">
            <img src="./assets/img/logo-projects/Logo.png">
          </div>
          <div class="title">
            <h4>
              Khảo sát thực trạng <br> giáo dục người khuyết tật
            </h4>
          </div>
          <div class="code">
            <div class="title">
              <h4>Mã phiếu</h4>
            </div>
            <div class="form-code">
              <form>
                <input *ngFor="let inp of inputCode" type="text" max="1">
              </form>
            </div>
          </div>
      </div>
      <div class="description">
        <h4 class="title">
          PHIẾU HỎI DÀNH CHO GIA ĐÌNH NGƯỜI KHUYẾT TẬT
        </h4>
        <p class="indent">
          Để thu thập dữ liệu cho quản lý giáo dục người khuyết tật Việt Nam, Mong Ông/ Bà/ vui lòng cung cấp thông tin theo các nội dung dưới đây bằng cách <span class="bold">đánh dấu (X) vào • phương án lựa chọn hoặc điền thông tin vào các chỗ (……).</span> Các thông tin chỉ được dùng cho mục đích chăm sóc giáo dục người khuyết tật. Các thông tin cá nhân được bảo mật. Trân trọng cảm ơn sự hợp tác của Ông/ Bà.
        </p>
          <form>
            <h4 class="title prirmary">
              A. Thông tin chung
            </h4>
            <h4 class="title second">
              A1. Thông tin người giám hộ
            </h4>
            <div class="item-form">
              <div nz-row [nzGutter]="[24,24]" >
                <div nz-col [nzSpan]="12">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">1. Giới tính</nz-form-label>
                    <nz-form-control>
                      <!-- <input nz-input placeholder="placeholder" /> -->
                      <nz-radio-group [(ngModel)]="gender" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="Nam">Nam</label>
                        <label nz-radio nzValue="Nu">Nữ</label>
                      </nz-radio-group>  
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">2. Dân tộc</nz-form-label>
                    <nz-form-control>
                      <input nz-input/>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>   
              <div nz-row [nzGutter]="[24,24]">
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">3. Chỗ ở hiện nay</nz-form-label>
                    <nz-form-control>
                      <input nz-input/> 
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>  
              <div nz-row [nzGutter]="[24,24]">
                <div nz-col [nzSpan]="10">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">4. Điện thoại</nz-form-label>
                    <nz-form-control>
                      <input nz-input/> 
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="14">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">5. Email (nếu có)</nz-form-label>
                    <nz-form-control>
                      <input nz-input/> 
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>  
              <div nz-row [nzGutter]="[24,24]">
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">6. Nghề nghiệp</nz-form-label>
                    <nz-form-control>
                      <input nz-input/> 
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>  
              <div nz-row [nzGutter]="[24,24]">
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">7. Mối quan hệ với người khuyết tật</nz-form-label>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="relationship" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">Bố</label>
                        <label nz-radio nzValue="2">Mẹ</label>
                        <label nz-radio nzValue="3">Vợ/chồng</label>
                        <label nz-radio nzValue="4">Anh/chị/em</label>
                        <label nz-radio nzValue="5">Người giám hộ</label>
                      </nz-radio-group>  
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>  
              <div nz-row [nzGutter]="[24,24]">
                <div nz-col [nzSpan]="24" class="option-radio">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">8. Trình độ đào tạo</nz-form-label>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="relationship2" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">Trung cấp</label>
                        <label nz-radio nzValue="2">Cao đẳng</label>
                        <label nz-radio nzValue="3">Đại học</label>
                        <label nz-radio nzValue="4">Sau đại học</label>
                        <label nz-radio nzValue="5">Khác:</label>
                        <input nz-input [disabled]="relationship2 != '5'"/>
                      </nz-radio-group>  
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>  
              <div nz-row [nzGutter]="[24,24]">
                <div nz-col [nzSpan]="24" class="option-radio">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">9. Đào tạo chưa bồ dưỡng về GD người khuyết tật</nz-form-label>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="relationship3" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">Chưa</label>
                        <label nz-radio nzValue="2">Có (cụ thể):</label>
                        <input nz-input [disabled]="relationship3 != '2'"/>
                      </nz-radio-group>  
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>  
            </div>
            <h4 class="title second">
              A2. Thông tin người khuyết tật
            </h4>
            <div class="item-form">
              <div nz-row [nzGutter]="[24,24]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">1. Giới tính</nz-form-label>
                    <nz-form-control>
                      <!-- <input nz-input placeholder="placeholder" /> -->
                      <nz-radio-group [(ngModel)]="gender100" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="Nam">Nam</label>
                        <label nz-radio nzValue="Nu">Nữ</label>
                      </nz-radio-group>  
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div> 
              <div nz-row [nzGutter]="[24,24]" >
                <div nz-col [nzSpan]="8">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">2. Năm sinh</nz-form-label>
                    <nz-form-control>
                      <nz-date-picker nzMode="year" nzPlaceHolder="Chọn năm sinh"></nz-date-picker>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div> 
              <div nz-row [nzGutter]="[24,24]" >
                <div nz-col [nzSpan]="8">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">3. Dân tộc</nz-form-label>
                    <nz-form-control>
                      <input nz-input />
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div> 
              <div nz-row [nzGutter]="[24,24]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" [nzFor]="'field'">4. Dạng tật (theo giấy xác nhận hoặc nghi ngờ):</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                      <div nz-row [nzGutter]="[24,24]">
                        <div nz-col [nzSpan]="24">
                          <nz-radio-group  [(ngModel)]="gender101" [ngModelOptions]="{standalone :true}">
                            <label nz-radio nzValue="1">KT Vận động </label>
                            <label nz-radio nzValue="2">KT nhìn</label>
                            <label nz-radio nzValue="3">KT nghe - nói</label>
                            <label nz-radio nzValue="4">KT thần kinh- tâm thần</label>
                            <label nz-radio nzValue="5">KT trí tuệ</label>
                            <label nz-radio nzValue="6">Rối loạn phổ tự kỷ</label>
                            <label nz-radio nzValue="7">Khuyết tật đọc viết/tính toán</label>
                            <label nz-radio nzValue="8" class="label-order">Khác (cụ thể):</label>
                            <input nz-input [disabled]="gender101 != '8'"/>
                          </nz-radio-group>
                        </div>          
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div> 
              <div nz-row [nzGutter]="[24,24]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">5. Mức độ khuyết tật</nz-form-label>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="gender102" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">Đặc biệt nặng</label>
                        <label nz-radio nzValue="2">Nặng</label>
                        <label nz-radio nzValue="3">Nhẹ</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div> 
              <div nz-row [nzGutter]="[24,12]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-label [nzFor]="'field'">6. Tình trạng giáo dục</nz-form-label>
                </div>
                <div nz-col [nzSpan]="12" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender3" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">Đang đi học (lớp/năm thứ):</label>
                        <input nz-input [disabled]="gender3 != '1'"/>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">Hình thức giáo dục</nz-form-label>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="gender109" [ngModelOptions]="{standalone :true}" [nzDisabled]="gender3 != '1'">
                        <label nz-radio nzValue="1">Đặc biệt nặng</label>
                        <label nz-radio nzValue="2">Nặng</label>
                        <label nz-radio nzValue="3">Nhẹ</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender3" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="2">Bỏ học (lớp/năm thứ) :</label>
                        <input nz-input [disabled]="gender3 != '2'"/>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>    
                <div nz-col [nzSpan]="12" class="option-radio">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">Lí do</nz-form-label>
                    <nz-form-control>
                      <input nz-input [disabled]="gender3 != '2'"/>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="24" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender3" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="3">Chưa đi học (Lí do) :</label>
                        <input nz-input [disabled]="gender3 != '3'"/>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>     
                <div nz-col [nzSpan]="24" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender3" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="4">Đã hoàn thành (Cấp học/ trình độ đào tạo) :</label>
                        <input nz-input [disabled]="gender3 != '4'"/>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>     
              </div>
              <div nz-row [nzGutter]="[24,12]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">7.Tình trạng can thiệp (đã hoặc đang can thiệp)</nz-form-label>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="gender107" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">Chưa </label>
                        <label nz-radio nzValue="2">có (cụ thể)</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="24" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="gender6" [ngModelOptions]="{standalone :true}" [nzDisabled]="gender107 !== '2'">
                        <label nz-radio nzValue="1">Can thiệp y tế (PHCN, phẫu thuật)   </label>
                        <label nz-radio nzValue="2">Can thiệp giáo dục</label>
                        <label nz-radio nzValue="3">Trợ giúp xã hội</label>
                        <label nz-radio nzValue="4">Khác</label>
                        <input nz-input [disabled]="gender6 != '4'"/>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>  
              <div nz-row [nzGutter]="[24,12]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-label [nzFor]="'field'">6. Tình trạng việc làm</nz-form-label>
                </div>
                <div nz-col [nzSpan]="24" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender7" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">Chưa đi làm (lí do)</label>
                        <input nz-input [disabled]="gender7 != '1'"/>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="24" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender7" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="2">Đã đi làm nhưng hiện nghỉ việc (lí do)</label>
                        <input nz-input [disabled]="gender7 != '2'"/>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="24" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender7" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="3">Đang đi làm (nghề cụ thể)</label>
                        <input nz-input [disabled]="gender7 != '3'"/>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-row [nzGutter]="[24,24]" >
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'field'">7. Tình trạng hôn nhân</nz-form-label>
                      <nz-form-control>
                        <nz-radio-group [(ngModel)]="gender8" [ngModelOptions]="{standalone :true}">
                          <label nz-radio nzValue="1">Chưa kết hôn</label>
                          <label nz-radio nzValue="2">Đã kết hôn</label>
                        </nz-radio-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div> 
              </div>
            </div>
            <h4 class="title prirmary">
              B. NỘI DUNG KHẢO SÁT
            </h4>
            <h4 class="title second">
              I.NHẬN THỨC VỀ CHÍNH SÁCH GIÁO DỤC CHO NGƯỜI KHUYẾT TẬT
            </h4>
            <div class="item-form">
              <div nz-row [nzGutter]="[24,12]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">1.	Biết chính sách GD cho người khuyết tật</nz-form-label>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="gender9" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">không </label>
                        <label nz-radio nzValue="2">có (cụ thể)</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-control>
                        <label nz-checkbox [nzDisabled]="gender9 !== '2'"  [(ngModel)]="checkbox" [ngModelOptions]="{standalone: true}">Ưu tiên nhập học và tuyển sinh</label>
                        <label nz-checkbox [nzDisabled]="gender9 !== '2'"  [(ngModel)]="checkbox1" [ngModelOptions]="{standalone: true}">Miễn giảm một số môn học, hoặc nội dung giáo dục</label>
                        <label nz-checkbox [nzDisabled]="gender9 !== '2'"  [(ngModel)]="checkbox2" [ngModelOptions]="{standalone: true}">Đánh giá kết quả giáo dục xét lên lớp và cấp bằng tốt nghiệp</label>
                        <label nz-checkbox [nzDisabled]="gender9 !== '2'"  [(ngModel)]="checkbox3" [ngModelOptions]="{standalone: true}">Học phí</label>
                        <label nz-checkbox [nzDisabled]="gender9 !== '2'"  [(ngModel)]="checkbox4" [ngModelOptions]="{standalone: true}">Hỗ trợ phương tiện, đồ dùng học tập</label>
                        <label nz-checkbox [nzDisabled]="gender9 !== '2'"  [(ngModel)]="checkbox5" [ngModelOptions]="{standalone: true}">PHCN</label>
                        <label nz-checkbox [nzDisabled]="gender9 !== '2'"  [(ngModel)]="checkbox6" [ngModelOptions]="{standalone: true}">Ưu tiên trong đào tạo nghề</label>
                        <label nz-checkbox [nzDisabled]="gender9 !== '2'"  [(ngModel)]="checkbox7" [ngModelOptions]="{standalone: true}">Cấp thẻ BHYT</label>
                        <label nz-checkbox [nzDisabled]="gender9 !== '2'"  [(ngModel)]="checkbox8" [ngModelOptions]="{standalone: true}">Ưu tiên trong tuyển dụng</label>
                        <label nz-checkbox [nzDisabled]="gender9 !== '2'"  [(ngModel)]="checkbox9" [ngModelOptions]="{standalone: true}">Trợ cấp xã hội </label>
                        <label nz-checkbox [nzDisabled]="gender9 !== '2'"  [(ngModel)]="checkbox10" [ngModelOptions]="{standalone: true}" class="label-order">Khác</label>
                        <input nz-input [disabled]="checkbox10 != true"/>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <div nz-row [nzGutter]="[24,12]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">2. Tiếp nhận thông tin từ nguồn</nz-form-label>
                    <nz-form-control>
                        <label nz-checkbox [(ngModel)]="checkbox11" [ngModelOptions]="{standalone: true}">Phương tiện truyền thông </label>
                        <label nz-checkbox [(ngModel)]="checkbox12" [ngModelOptions]="{standalone: true}">Gia đình hoặc người giám hộ</label>
                        <label nz-checkbox [(ngModel)]="checkbox13" [ngModelOptions]="{standalone: true}">Chính quyền, đoàn thể</label>
                        <label nz-checkbox [(ngModel)]="checkbox14" [ngModelOptions]="{standalone: true}">Cơ sở giáo dục </label>
                        <label nz-checkbox [(ngModel)]="checkbox15" [ngModelOptions]="{standalone: true}" class="label-order">Khác (cụ thể):</label>
                        <input nz-input [disabled]="checkbox15 != true"/>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <div nz-row [nzGutter]="[24,0]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-label [nzFor]="'field'">3 .Sự phối hợp của cộng đồng trong thực hiện chính sách giáo dục cho người khuyết tật</nz-form-label>
                </div>
                <div nz-col [nzSpan]="24" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender12" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">Không</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="4" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender12" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="2">có (mức độ cụ thể)</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="20" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender13" [ngModelOptions]="{standalone :true}" [nzDisabled]="gender12 !== '2'">
                        <label nz-radio nzValue="1">Rất chặc chẽ</label>
                        <label nz-radio nzValue="2">Chặc chẽ</label>
                        <label nz-radio nzValue="3">Chưa chặc chẽ</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <div nz-row [nzGutter]="[24,0]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-label [nzFor]="'field'">4 .Sự phối hợp của chính quyền và ban, ngành địa phương:</nz-form-label>
                </div>
                <div nz-col [nzSpan]="24" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender14" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">Không</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="4" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender14" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">có (mức độ cụ thể)</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="20" class="option-radio">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group nzSpan="24" [(ngModel)]="gender15" [ngModelOptions]="{standalone :true}" [nzDisabled]="gender14 !== '2'">
                        <label nz-radio nzValue="1">Rất chặc chẽ</label>
                        <label nz-radio nzValue="2">Chặc chẽ</label>
                        <label nz-radio nzValue="3">Chưa chặc chẽ</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>   
            </div>
            <h4 class="title second">
              I.KIẾN THỨC VÀ KHẢ NĂNG CHĂM SÓC NGƯỜI KHUYẾT TẬT
            </h4>
            <div class="item-form">
              <div nz-row [nzGutter]="[24,12]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">1.	Ông/bà đã được đào tạo/ bồi dưỡng về chăm sóc GD và hỗ trợ người khuyết tật chưa?</nz-form-label>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="gender16" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">Chưa tham gia</label>
                        <label nz-radio nzValue="2">Đã tham gia(Điền tiếp thông tin phần phía dưới)</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">Nội dung đã được đạo đào và bồi dưỡng</nz-form-label>
                    <nz-form-control>
                        <label nz-checkbox [nzDisabled]="gender16 !== '2'" [(ngModel)]="checkbox16" [ngModelOptions]="{standalone :true}">Về Phục hồi chức năng</label>
                        <label nz-checkbox  [nzDisabled]="gender16 !== '2'" [(ngModel)]="checkbox17" [ngModelOptions]="{standalone :true}">Về giáo dục người khuyết tật</label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">Sau khóa học đã được cấp</nz-form-label>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="gender18 " [ngModelOptions]="{standalone :true}" [nzDisabled]="gender16 !== '2'">
                        <label nz-radio nzValue="1">Chứng nhận</label>
                        <label nz-radio nzValue="2">Chứng chỉ</label>
                        <label nz-radio nzValue="3" class="label-order">Bằng (ghi cụ thể)</label>
                        <input nz-input [disabled]="gender18 !== '3'"/>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <div nz-row [nzGutter]="[24,12]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-label [nzFor]="'field'">2.	Đào tạo bồi dưỡng về kỹ năng chăm sóc người khuyết tật</nz-form-label>
                </div>
                <div nz-col [nzSpan]="24">
                  <nz-table #basicTable [nzData]="listOfData" [nzShowPagination]="false" [nzSize]="'small'" [nzBordered]="true">
                    <thead>
                      <tr>
                        <th rowspan="2">STT</th>
                        <th rowspan="2">Loại kỹ năng</th>
                        <th colspan="2">Đã được đào tạo - bồi dưỡng</th>
                        <th colspan="2">Nhu cầu được đào tạo bồi dưỡng</th>
                      </tr>
                      <tr>
                        <th nzAlign="center">Có</th>
                        <th nzAlign="center">Chưa</th>
                        <th nzAlign="center">Có</th>
                        <th nzAlign="center">Chưa</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let data of basicTable.data">
                        <td>{{ data.stt }}</td>
                        <td>{{ data.type }}</td>
                        <td><label nz-checkbox [(ngModel)]="data.isTrain" [ngModelOptions]="{standalone :true}"></label></td>
                        <td><label nz-checkbox [(ngModel)]="data.isTrain" [ngModelOptions]="{standalone :true}"></label></td>
                        <td><label nz-checkbox [(ngModel)]="data.isNeed" [ngModelOptions]="{standalone :true}"></label></td>
                        <td><label nz-checkbox [(ngModel)]="data.isNeed" [ngModelOptions]="{standalone :true}"></label></td>
                      </tr>
                    </tbody>
                  </nz-table>
                </div>
              </div>
              <div nz-row [nzGutter]="[24,0]" >
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'">3.	Mong muốn của ông/bà đối với người khuyết tật được hỗ trợ tiếp cận giáo dục</nz-form-label>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="gender19" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="1">Can thiệp sớm</label>
                        <label nz-radio nzValue="2">Giáo dục chuyên biệt</label>
                        <label nz-radio nzValue="3">Giáo dục hòa nhập</label>
                        <label nz-radio nzValue="4">Giáo dục hòa nhập</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="gender19" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="5">Học nghề, cụ thể</label>
                        <input nz-input [disabled]="gender19 !== '5'"/>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="gender19" [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="6">Hỗ trợ thiết bị, phương tiện phục vụ học tập, (cụ thể)</label>
                        <input nz-input [disabled]="gender19 !== '6'"/>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-radio-group [(ngModel)]="gender19 " [ngModelOptions]="{standalone :true}">
                        <label nz-radio nzValue="7">Khác</label>
                        <input nz-input [disabled]="gender19 != '7'"/>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
            </div>   
          </form>
          <div class="end">
            <h4 class="title second">
              Trân trọng cảm ơn!
            </h4>
          </div>
        </div>
    </nz-card>
  </div>
</div>
